import axios from 'axios'

const BASE_URL: string = ''

class HttpRequest {
  constructor (baseURL: string = BASE_URL) {
    this.baseURL = baseURL
    this.queue = []
  }
  private baseURL: string = ''
  private queue: any = {} // 请求队列
  private getInitialConfig () {
    return {
      baseURL: this.baseURL,
      header: {},
      // timeout: 5000
    }
  }
  private interceptors (instance: any, url: string) {
    instance.interceptors.request.use((config: any) => {
      if (!Object.keys(this.queue).length) {
        // 请求队列为空，如果有全局 Loading，则隐藏
      }
      this.queue[url] = true
      return config
    }, (error: any) => {
      return Promise.reject(error)
    })
    instance.interceptors.response.use((res: any) => {
      delete this.queue[url]
      const { data } = res
      return data
    }, (error: any) => {
      delete this.queue[url]
      if (error.response) {
        console.log('有错误消息')
      }
      return Promise.reject(error)
    })
  }
  public request (options: any) {
    const instance = axios.create()
    let opt: any = Object.assign(this.getInitialConfig(), options)
    this.interceptors(instance, opt.url)
    return instance(opt)
  }
}

export default HttpRequest
